<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
      <TableSearchFilter
        :search="filterValue"
        @search="updateSearch" 
        @showType="showType"
        :filters="filterConfig"
        :noResetCall="true"
      />
      <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:showDataParent="showData"
          v-on:exportItemParent="exportItem"
          v-on:exportExcelParent="exportExcel"
          :switchCh="switchCh"
          v-on:onSwitch="handleSwitch"
        />
      </template>
      <template v-slot:tooltip__qr_method="{ item }">
          <TooltipInformation
            :value="item.qr_method"
            :description="getTooltipMethod(item)"
          />
        </template>
      <template v-slot:tooltip__payment_type="{ item }">
          <TooltipInformation
            :value="item.payment_type"
            :description="getTooltipPayement(item)"
          />
        </template>
        <template v-slot:body-prepend>
          <BodyFilterView
            :filters="filterData"
            :search.sync="search"
            :options.sync="options"
            @getDataParent="getData"
          />
        </template>
        <template slot="action" slot-scope="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="view" max-width="500px">
      <table-detail-vue
        :editedItem="detailData"
        :loading="detailLoading"
        v-on:closeParent="close"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import reportBpjstkMixin from '../../components/report/bpjstk/reportBpjstkMixin';

export default {
  mixins: [ reportBpjstkMixin ],
  components: {
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    TableDetailVue: () => import('../../components/table/BpjstkDetail.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../components/@drontVue/components/BodyFilter"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TooltipInformation: () => import("../../components/@drontVue/components/TooltipInformation")
  }
};
</script>
